module.exports = __webpack_public_path__ + "img/resource-tech-image-07.b735fabb.jpg";